<template>
  <div>
    <div class="bg-light py-2 mb-3">
      <div v-if="!runningBreak" class="m-3 text-center">
        <h1>Round {{ round }} - {{ displayedTime(time) }}
          <b-button v-if="finished" @click="reset">Reset</b-button>
        </h1>
        <div v-if="!finished">
          <b-button
            class="mx-1 px-5 py-3"
            variant="primary" v-if="!running && !roundEnded" @click="startClock">Start</b-button>
          <b-button class="mx-1" v-if="fightStarted && !running" @click="finish">Finish</b-button>
          <b-button class="mx-1" v-if="roundEnded" @click="nextRound">Next Round</b-button>
          <b-button class="mx-1" v-if="!running" @click="increaseTime">+</b-button>
          <b-button class="mx-1" v-if="!running" @click="decreaseTime">-</b-button>
        </div>
        <b-button class="mx-1 px-5 py-3" variant="danger" v-if="running" @click="stopClock"
        >Stop</b-button>
      </div>
      <div v-if="runningBreak">
        <h1>Break {{ displayedTime(timeBreak) }}</h1>
        <b-button variant="light">-</b-button>
      </div>
    </div>

    <b-row>
      <b-col>
        <b-form-group label="Fight Number:" label-for="fight-number">
          <b-form-input value="5" disabled></b-form-input>
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group label="Weight class:" label-for="weightclass">
          <b-form-input value="Lightweight" disabled></b-form-input>
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group label="Bracket:" label-for="bracket">
          <b-input type="text" value="Semi-Finals" disabled/>
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group label="Type:" label-for="type">
          <b-input type="text" value="Amateur" disabled/>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col class="table-danger">
        <b-form-group label="Red Corner:" label-for="redcorner">
          <b-input type="text" value="Jerry" disabled/>
        </b-form-group>
      </b-col>
      <b-col class="table-primary">
        <b-form-group label="Blue Corner:" label-for="bluecorner">
          <b-input type="text" value="Tom" disabled/>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-form-group label="Winner:" label-for="winner">
          <b-select id="winner">
            <b-select-option></b-select-option>
            <b-select-option>Jerry</b-select-option>
            <b-select-option>Tom</b-select-option>
            <b-select-option>Draw</b-select-option>
          </b-select>
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group label="Won by:" label-for="won-by">
          <b-select id="won-by">
            <b-select-option></b-select-option>
            <b-select-option>KO/TKO</b-select-option>
            <b-select-option>Submission</b-select-option>
            <b-select-option>Decision</b-select-option>
          </b-select>
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group label="Round:" label-for="round">
          <b-select id="round" :options="[1,2,3,4,5]"/>
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group label="Time:" label-for="time">
          <b-input type="time" id="time"/>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-form-group label="Referee:" label-for="referee">
          <b-select id="referee">
            <b-select-option>Franz Schwerdtmann</b-select-option>
            <b-select-option>Gerd Richter</b-select-option>
          </b-select>
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group label="Timekeeper:" label-for="timekeeper">
          <b-select id="timekeeper">
            <b-select-option>Victor Wolf</b-select-option>
          </b-select>
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group label="Scorekeeper:" label-for="scorekeeper">
          <b-select id="scorekeeper">
            <b-select-option>Tina Huynh</b-select-option>
          </b-select>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col class="table-light">
        <b-form-group label="Judge 1:" label-for="judge1">
          <b-select id="judge1">
            <b-select-option>Clemens Werner</b-select-option>
            <b-select-option>Montserrat Alvarez</b-select-option>
            <b-select-option>Takeo Kobayashi</b-select-option>
          </b-select>
        </b-form-group>
        <Scorecard judge="Clemens Werner"/>
      </b-col>
      <b-col class="table-warning">
        <b-form-group label="Judge 2:" label-for="judge2">
          <b-select id="judge2">
            <b-select-option>Clemens Werner</b-select-option>
            <b-select-option>Montserrat Alvarez</b-select-option>
            <b-select-option>Takeo Kobayashi</b-select-option>
          </b-select>
        </b-form-group>
        <Scorecard judge="Montserrat Alvarez"/>
      </b-col>
      <b-col class="table-success">
        <b-form-group label="Judge 3:" label-for="judge3">
          <b-select id="judge3">
            <b-select-option>Clemens Werner</b-select-option>
            <b-select-option>Montserrat Alvarez</b-select-option>
            <b-select-option>Takeo Kobayashi</b-select-option>
          </b-select>
        </b-form-group>
        <Scorecard judge="Takeo Kobayashi"/>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Scorecard from './Scorecard.vue';

export default {
  name: 'MatchDetail',
  components: { Scorecard },
  data() {
    return {
      round: 1,
      end: 180,
      endBreak: 60,
      time: 0,
      timeBreak: 0,
      fightStarted: false,
      running: false,
      runningBreak: false,
      roundEnded: false,
      finished: false,
      update: null,
      updateBreak: null,
    };
  },
  methods: {
    closeDetail() {
      this.$store.commit('setTournament', { value: true });
    },
    displayedTime(clock) {
      const minutes = String(Math.floor(clock / 60));
      const seconds = String(clock % 60);
      return `${minutes}:${seconds.padStart(2, 0)}`;
    },
    decreaseTime() {
      if (this.time > 0) this.time -= 1;
    },
    increaseTime() {
      if (this.time < this.end) this.time += 1;
    },
    finish() {
      this.finished = true;
      clearInterval(this.update);
      clearInterval(this.updateBreak);
    },
    reset() {
      this.round = 1;
      this.time = 0;
      this.timeBreak = 0;
      this.fightStarted = false;
      this.running = false;
      this.runningBreak = false;
      this.roundEnded = false;
      this.finished = false;
      this.update = null;
      this.updateBreak = null;
    },
    startClock() {
      this.fightStarted = true;
      this.running = true;
      this.update = setInterval(() => {
        if (this.time >= this.end - 1) {
          this.running = false;
          clearInterval(this.update);
          this.roundEnded = true;
          this.startBreakClock();
        }
        this.time += 1;
      }, 20);
    },
    startBreakClock() {
      this.runningBreak = true;
      this.updateBreak = setInterval(() => {
        if (this.timeBreak >= this.endBreak - 1) {
          this.runningBreak = false;
          clearInterval(this.updateBreak);
          this.round += 1;
          this.time = 0;
          this.timeBreak = 0;
          this.roundEnded = false;
        }
        this.timeBreak += 1;
      }, 60);
    },
    stopClock() {
      this.running = false;
      clearInterval(this.update);
    },
  },
};
</script>

<style scoped>
</style>
